import i18next from "i18next";
import {
  globalSystemConstants,
  invoiceConstants,
  translationConstants,
} from "../../constants";
import { ToastifyService } from "../../services";
import { invoiceService } from "../../services/invoice.service";
import { custom, success } from "./utilities";

export const getInvoice = (paymentId, onSuccess) => {
  return (dispatch) => {
    dispatch(
      custom(invoiceConstants.SPINNER, globalSystemConstants.SPINNER_ACTIVATE)
    );
    invoiceService
      .getInvoice(paymentId)
      .then((response) => {
        dispatch(success(response, invoiceConstants.INVOICE_DATA));
        if (response?.creditNoteLink != null) {
          onSuccess();
        } else if (response?.invoiceLink) {
          window.open(response?.invoiceLink, "_blank", "noreferrer");
        } else {
          ToastifyService.showError(
            translationConstants.INVOICE_LINK_NOT_AVAILABLE
          );
        }
      })
      .catch((error) => ToastifyService.showError(error))
      .finally(() => {
        dispatch(
          custom(
            invoiceConstants.SPINNER,
            globalSystemConstants.SPINNER_DEACTIVATE
          )
        );
      });
  };
};

export const setInvoiceDataNull = () => {
  return (dispatch) => {
    dispatch(success(null, invoiceConstants.INVOICE_DATA_NULL));
  };
};

export const invoiceActions = {
  getInvoice,
  setInvoiceDataNull,
};
